import React from 'react';

const FlashcardNavigation = ({ currentCardIndex, cards, goToPreviousCard, goToNextCard }) => {
  return (
    <div className="navigation">
      <button className="flash-button" onClick={goToPreviousCard} disabled={currentCardIndex === 0}>
        Previous
      </button>
      <h3 className='h3'>{currentCardIndex + 1} / {cards.length}</h3>
      <button className="flash-button" onClick={goToNextCard} disabled={currentCardIndex === cards.length - 1}>
        Next
      </button>
    </div>
  );
};

export default FlashcardNavigation;